export default "__VITE_ASSET__C8_h95ui__"